var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"800px","margin":"0 auto","position":"relative"}},[_c('div',{staticStyle:{"width":"800px","height":"600px"}},[_c('simple-chart',{attrs:{"option":_vm.option}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }